import Reveal from '@/components/base/Reveal';
import { subForums } from '@/mocks/homeData';

function SubForumGrid() {
  return (
    <section id="subforums" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl">
          <Reveal>
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
              <div>
                <span className="inline-flex items-center gap-1.5 text-xs font-label text-secondary-700 uppercase tracking-widest">
                  <i className="ri-links-line" />
                  Sub Forums
                </span>
                <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
                  子版主页入口
                </h2>
                <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600 font-label leading-relaxed">
                  各分区下最常用的子版主页集中在这里。图标化排列，找入口不用层层点进去。
                </p>
              </div>
              <span className="inline-flex items-center gap-1 h-9 px-3 rounded-full bg-background-50 border border-background-200 text-xs font-label text-foreground-700 whitespace-nowrap shrink-0">
                <i className="ri-apps-2-line" />
                共 8 个常用入口
              </span>
            </div>
          </Reveal>

          <div className="mt-9 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
            {subForums.map((item, index) => (
              <Reveal key={item.name} delay={index * 40}>
                <a
                  href="#latest"
                  className="group block h-full rounded-lg bg-background-50 border border-background-200 p-4 md:p-5 hover:border-primary-300 transition-colors"
                >
                  <span className="flex items-center justify-center w-11 h-11 rounded-md bg-background-100 text-xl text-foreground-800 group-hover:bg-accent-500 group-hover:text-foreground-950 transition-colors">
                    <i className={item.icon} />
                  </span>
                  <h4 className="mt-3.5 font-heading text-base font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {item.name}
                  </h4>
                  <p className="mt-1 text-xs font-label text-foreground-500">所属 {item.parent}</p>
                  <div className="mt-3 flex items-center justify-between border-t border-background-200 pt-3">
                    <span className="text-[11px] font-label text-foreground-500">{item.count} 个话题</span>
                    <span className="flex items-center justify-center w-7 h-7 rounded-md bg-background-100 text-foreground-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                      <i className="ri-arrow-right-line text-sm" />
                    </span>
                  </div>
                </a>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default SubForumGrid;